import Backbone from 'backbone';
import ko from 'knockout';
import _ from 'underscore';

import textWithHeaderTemplate from './text-template.pug';

export class TextWithCustomValidatorView extends Backbone.View {
  initialize({
    observable,
    field,
    headerText = null,
  }) {
    if (observable.validators.required) {
      // re-write validator to ignore when field is not visible
      observable.validators.required.isValid = () => { //eslint-disable-line
        if (observable.visible()) {
          return _.isString(observable()) && _.size(observable()) > 0;
        }
        return true;
      };
    }

    this.viewModel = {
      observable,
    };
    this.field = field;
    this.headerText = headerText;
  }

  render() {
    this.$el.html(textWithHeaderTemplate({
      headerText: this.headerText,
      field: this.field,
    }));

    ko.applyBindings(this.viewModel, this.el);

    return this;
  }
}
